import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import * as React from "react";

import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticTimePicker } from "@mui/x-date-pickers/StaticTimePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import {
  AI_setWorkingProject,
  AI_showProjectEmployeeList,
} from "APIs/projectEmployee";
import { AI_employeeForgotPunch, AI_getUserData } from "APIs/user";
import CommonButton from "components/common-component/Button";
import { useInstance } from "easy-redux-http-call";
import { useAIEventHandler } from "easy-redux-http-call/dist/index";
import moment from "moment";
import { SEND_NOTIFICATION } from "reducers/NotificationReducer";
import { store } from "store";

const useStyle = makeStyles((theme) => ({
  marginLeft: {
    marginLeft: "20px",
  },
  dialog: {
    position: "absolute",
    top: 50,
    width: 500,
    [theme.breakpoints.between("xs", "sm")]: {
      width: "80%",
    },
  },
  hrDialogTitle: {
    display: "flex",
    gap: "10px",
  },
  hrDialogSubTitle: {
    textAlign: "left",
  },
  hrClosebtn: {
    position: "absolute",
    right: 8,
    top: 8,
    color: theme.palette.grey[500],
  },
  hrmsProjectEmployeeTable: {
    maxHeight: "250px",
    overflowY: "auto",
    width: "100%",
    "&::-webkit-scrollbar": {
      width: "10px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#ff7f50",
      borderRadius: "5px",
    },
    "&::-webkit-scrollbar-thumb:active": {
      backgroundColor: "#ff5733",
    },
  },
  staticTimePickerDesign: {
    "& .MuiDialogActions-root": {
      display: "none",
    },
  },
}));
const MissPunch = (props) => {
  const classes = useStyle();
  const { openStatus = false, handleCloseAction = () => {} } = props;
  const submitResponse = useInstance(AI_employeeForgotPunch);
  const getUserData = useInstance(AI_getUserData);
  const projectDetails = useInstance(AI_showProjectEmployeeList);
  const [isWorking, setIsWorking] = React.useState(null);

  // Set Default as ' PM '  (changed default to 7:30pm)

  let defaultTime = moment().hours(19).minute(30);

  const [selectedDate, setSelectedDate] = React.useState(defaultTime);

  const handleSubmit = () => {
    AI_employeeForgotPunch.call({
      params: {
        hour: selectedDate.hours(),
        min: selectedDate.minute(),
      },
    });
  };

  React.useEffect(() => {
    if (getUserData?.data?.user?.employee_id !== undefined) {
      AI_showProjectEmployeeList.call({
        urlParams: { id: getUserData?.data?.user?.employee_id },
      });
    }
  }, [getUserData]);

  useAIEventHandler(AI_employeeForgotPunch, {
    onSuccess: () => {
      AI_getUserData.call();
      if (!getUserData?.data?.user?.is_login) {
        AI_setWorkingProject.call({
          params: {
            project_id: isWorking,
            employee_id: getUserData?.data?.user?.employee_id,
          },
        });
      }
    },
    onError: (res) =>
      store.dispatch({
        type: SEND_NOTIFICATION,
        payload: {
          message: res.error.message || "Somthing went wrong!",
          variant: "error",
        },
      }),
  });

  useAIEventHandler(AI_setWorkingProject, {
    onSuccess: () => {
      AI_getUserData.call();
      setIsWorking(null);
      handleCloseAction();
    },
  });

  const [timeAndDate, setTimeAndDate] = React.useState({
    hours: moment().hours(),
    min: moment().minute(),
  });

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeAndDate({
        hours: moment().hours(),
        min: moment().minute(),
      });
    }, [30000]);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  // Set  Default Time as Current Time
  // React.useEffect(() => {
  //   setSelectedDate(moment());
  // }, []);

  return (
    <Dialog
      open={openStatus}
      onClose={() => handleCloseAction()}
      classes={{ paper: classes.dialog }}
      fullWidth
    >
      <form
        noValidate
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <DialogTitle>
          <div className={classes.hrDialogTitle}>
            <Typography variant="h4" className={classes.hrDialogSubTitle}>
              When did you left?
            </Typography>
          </div>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DemoContainer components={["StaticTimePicker"]}>
              <StaticTimePicker
                className={classes.staticTimePickerDesign}
                value={selectedDate}
                onChange={handleDateChange}
              />
            </DemoContainer>
          </LocalizationProvider>
        </DialogContent>
        <DialogActions>
          <CommonButton
            variant="contained"
            loading={submitResponse.loading || AI_setWorkingProject.loading}
            type="submit"
          >
            Submit
          </CommonButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default MissPunch;
